import { createApp } from 'vue';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

// Plugins (alleen als ze Vue 3 ondersteunen!)
import VueGtag from 'vue-gtag-next';
import VueLazyLoad from 'vue3-lazyload';

const app = createApp(App);

// Google Analytics
app.use(VueGtag, {
    config: {
        id: "UA-173459685-1",
        anonymize_ip: true,
    },
}, router);

// Lazyload
app.use(VueLazyLoad);


// Router & store
app.use(router);
app.use(store);

// Mount app
app.mount('#app');

// Optional: dispatch custom event when app is mounted
document.dispatchEvent(new Event("x-app-rendered"));
